import script from "./TwitterConnection.vue?vue&type=script&setup=true&lang=js"
export * from "./TwitterConnection.vue?vue&type=script&setup=true&lang=js"

import "./TwitterConnection.vue?vue&type=style&index=0&id=d80a8b32&lang=scss&scoped=true"

import exportComponent from "/builds/aquaverse/thales/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d80a8b32"]])

export default __exports__